// GetStartedBanner — gradient teal banner shown above the audience builder
// canvas, inviting users new to the platform to take the intro tour.
//
// Always visible — there's no dismiss control, and nothing gates it on
// whether the tour has been completed before.

export type GetStartedBannerProps = {
  /** Called when the user clicks the CTA. */
  onTakeTour: () => void;
};

export default function GetStartedBanner({ onTakeTour }: GetStartedBannerProps) {
  return (
    <div
      data-tour="get-started-banner"
      role="region"
      aria-label="Get started"
      className="flex items-center justify-between bg-gradient-to-r from-primary to-primary-light text-white rounded-half px-5 py-3 mb-4 shadow"
    >
      <div className="flex items-center gap-3">
        <div
          aria-hidden="true"
          className="w-9 h-9 rounded-full bg-white bg-opacity-20 flex items-center justify-center font-extrabold text-lg"
        >
          ✨
        </div>
        <div>
          <div className="font-extrabold text-sm tracking-wide uppercase">
            Get started
          </div>
          <div className="text-sm">
            New here? Take a quick tour of the audience builder — drag in
            attributes, combine them with <span className="font-bold">AND</span>{' '}
            / <span className="font-bold">OR</span>, and see what&apos;s new in
            this data refresh.
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onTakeTour}
        className="bg-white text-primary-dark font-extrabold rounded-full px-4 py-1.5 text-sm hover:bg-gray-50"
      >
        Take the tour
      </button>
    </div>
  );
}
